import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { HeaderNotificationsEffects } from './header-notifications-effects';
import { headerNotificationsFeature } from './header-notifications-feature';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(headerNotificationsFeature),
    EffectsModule.forFeature(HeaderNotificationsEffects)
  ]
})
export class HeaderNotificationsFeatureStoreModule {
}
